<template>
  <div
    v-if="Object.keys(relativeIds).length && checkingLimit === 'done'"
    class="container"
  >
    <div class="title">
      继续编辑该视频
    </div>
    <div class="items-wrapper">
      <ul class="items">
        <li
          v-for="(item, key) in views"
          :key="key"
          class="item"
        >
          <router-link :to="item.path + '?pipe=1'">
            <!-- <div
              class="figure"
              :style="{ ...iconStyles[key] }"
            >
              <iconfont
                :name="'#icon' + item.icon"
                font-size="18px"
              ></iconfont>
            </div> -->
            <div class="link-iconUrl">
              <img
                :src="$.handleAssetsUrl(item.iconUrl)"
                alt=""
              >
            </div>
            <div class="caption">
              {{ item.text }}
            </div>
          </router-link>
        </li>
        <li
          v-if="Object.keys(otherViews).length > 1"
          class="item popper-wrapper more"
        >
          <el-popover
            v-model="popperVisible"
            placement="right-start"
            :width="85"
            :visible-arrow="false"
            trigger="hover"
            popper-class="popper"
          >
            <i
              slot="reference"
              class="popper-ref"
            ></i>
            <ul class="popper-items">
              <li
                v-for="(item, key) in otherViews"
                :key="key"
                class="popper-item"
              >
                <router-link :to="item.path + '?pipe=1'">
                  {{ item.text }}
                </router-link>
              </li>
            </ul>
          </el-popover>
          <div class="figure more">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
          <div class="caption">
            更多
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      iconStyles: {},
      popperVisible: false,
      checkingLimit: 'doing'
    };
  },
  computed: {
    ...mapGetters({
      viewDict: 'views/dict'
    }),
    relativeIds() {
      let dict = this.viewDict;
      let viewName = this.$route.path.slice(1);
      let view = dict[viewName];
      let ids = (view.origin || {}).relativeTools;
      try {
        ids = JSON.parse(ids);
      } catch (e) {
        ids = [];
        e;
      }
      return ids || [];
    },
    relativeTools() {
      let dict = this.viewDict;
      let ids = this.relativeIds;
      let newDict = {};
      Object.entries(dict)
        .filter((entry) => {
          return ids.indexOf((entry[1].origin || {}).id) > -1;
        })
        .forEach(([k, v]) => {
          newDict[k] = v;
        });
      return newDict;
    },
    views() {
      let count = 4;
      let dict = this.relativeTools;
      let newDict = {};
      if (Object.keys(dict).length <= 5) {
        count = 5;
      }
      Object.entries(dict)
        .filter((item, i) => i < count)
        .forEach(([key, item]) => {
          newDict[key] = item;
        });
      console.log('newDict===>', newDict);
      return newDict;
    },
    otherViews() {
      let dict = this.relativeTools;
      let newDict = {};
      Object.entries(dict)
        .filter((item, i) => i >= 4)
        .forEach(([key, item]) => {
          newDict[key] = item;
        });
      return newDict;
    }
  },
  created() {},
  mounted() {
    this.updateIconStyles();
    let doing = this.$parent.$parent.doingTasks;
    doing.then(() => {
      let formatedFiles = this.$store.getters['completed/getPipeFiles'];
      let oLen = formatedFiles.length;
      console.log('turbo: mounted -> oLen', oLen);
      formatedFiles = formatedFiles.filter((v) => v.duration && v.duration >= 1);
      console.log('turbo: mounted -> formatedFiles', formatedFiles);
      if (oLen > formatedFiles.length) {
        this.$message({
          message: '时长小于1秒的视频不能传递到其他办公宝',
          type: 'error'
        });
        this.$store.commit('completed/setPipeFiles', formatedFiles);
      }
      this.checkingLimit = 'done';
    });
  },
  methods: {
    updateIconStyles() {
      let dict = {};
      Object.entries(this.views).forEach(([k, v]) => {
        let colors = v.bgc && v.bgc.split(' ');
        let background = colors ? `linear-gradient(142deg, ${colors[0]} 0%, ${colors[1]} 100%)` : '';
        dict[k] = {
          background
        };
      });
      this.iconStyles = dict;
    },
    togglePopper(flag) {
      this.popperVisible = flag;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 12px;
  background-color: #fff;
}
.title {
  margin-bottom: 15px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  width: 400px;
  text-align: left;
}
.items {
  display: flex;
  align-items: center;
  width: 400px;
  height: 102px;
  background: #ffffff;
  border: 1px solid #d5d5d5;
  border-radius: 4px;
}
.item {
  margin-right: 28.6px;
  cursor: pointer;
  &:first-of-type {
    margin-left: 27px;
  }
  &.more {
    position: relative;
    & > span:first-of-type {
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: transparent;
      cursor: pointer;
      z-index: 1;
    }
    & .popper-ref {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
.item:hover {
  & .figure {
    transform: scale(1);
  }
}
.link-iconUrl {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  overflow: hidden;
  img {
    width: 100%;
    width: 100%;
  }
}
.figure {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  transform: scale(calc(40 / 46));
  transition-duration: 0.3s;
  background: linear-gradient(142deg, #3894ff 0%, #4ad9ff 100%);
  border-radius: 8px;
  color: #fff;
  &.more {
    position: relative;
    background-color: #fff;
    background: none;
    border: 1px solid #d6d6d6;
    & > .dot {
      position: absolute;
      top: calc(50% - 6px);
      left: 50%;
      width: 12px;
      height: 12px;
      background-color: #7a8298;
      border-radius: 50%;
      transform: scale(0.333);

      &:first-of-type {
        left: calc(50% - 6px);
      }
      &:last-of-type {
        left: calc(50% - 13px);
      }
    }
  }
}
.caption {
  margin-top: 6px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.popper-wrapper {
  position: relative;
}
.popper {
  position: absolute;
  top: 0;
  left: 100%;
  height: 64px;
}
.popper-items {
  margin-left: 12px;
  width: 85px;
  background: #ffffff;
  box-shadow: 0px 2px 9px 0px rgba(56, 58, 66, 0.2);
  border-radius: 4px;
  overflow: hidden;
  transform: translate(-5px, 0);
}
.popper-item {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  background-color: #fff;
  cursor: pointer;
  font-size: 12px;
  color: #343434;
  & a,
  & a:visited {
    color: #343434;
  }
  &:hover {
    background-color: #f6f7f9;
  }
}
</style>

<style lang="scss">
.popper.el-popover {
  width: 85px;
  padding: 0;
  background-color: transparent;
  box-shadow: none;
  border: none;
}
</style>
